import React from "react";
import ObjectAnalytics from "../components/ObjectAnalytics";

const Analytics: React.FC = () => {
  
  return (
    <ObjectAnalytics object={null} />
  )
}

export default Analytics;